var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HammerGestureConfig } from "@angular/platform-browser";
var MyHammerGestureConfig = /** @class */ (function (_super) {
    __extends(MyHammerGestureConfig, _super);
    function MyHammerGestureConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.overrides = {
            tap: { threshold: 70, posTreshold: 10, time: 2500 },
            pan: { threshold: 1000 },
            swipe: { threshold: 1000 },
        };
        return _this;
    }
    return MyHammerGestureConfig;
}(HammerGestureConfig));
export { MyHammerGestureConfig };
